module.exports = __webpack_public_path__ + "img/img4.42e88eae.png";